import { render, staticRenderFns } from "./BrandThree.vue?vue&type=template&id=7b1f4891&"
import script from "./BrandThree.vue?vue&type=script&lang=js&"
export * from "./BrandThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports